export const maxmindJavascriptApiUrl = `https://geoip-js.com/js/apis/geoip2/v2.1/geoip2.js`
export const recaptchaSiteKey = '6Le-HmkqAAAAAHT_1oJbSHMJAc2JMpL_0tUexu1r'
